import * as React from "react";
import { CircularProgress, Menu, MenuItem } from "@mui/material";
import "./ActionMenuIcon.scss";
import { useDispatch } from "react-redux";
import SubMenuThreeDotIcon from "../../../../components/icons/SubMenuThreeDotIcon";
import toast from "react-hot-toast";

interface ActionMenuIconProps {
  brandId: string;
  status: string;
  onAction?: (brandId: string, action: string) => void;
  canEdit: boolean;
}

const ActionMenuIcon: React.FC<ActionMenuIconProps> = ({
  brandId,
  status,
  onAction,
  canEdit,
}) => {
  const [state, setState] = React.useState({
    isLoading: false,
    menuOpen: false,
    anchorEl: null,
  });

  const open = Boolean(state?.anchorEl);

  const handleClick = (event: any) => {
    setState({ ...state, anchorEl: event.currentTarget });
  };

  const handleClose = () => {
    setState({ ...state, anchorEl: null });
  };

  const handleActionClick = (action: string) => {
    handleClose();
    if (!canEdit) {
      toast.error(
        "Permission denied. Only Super Admin can perform this action.",
      );
      return;
    }
    if (onAction) {
      onAction(brandId, action);
    }
  };

  const isArchived = status === "brand_archive";

  return (
    <>
      <div
        className="brand-menu-icon"
        onClick={handleClick}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        {state?.isLoading ? (
          <CircularProgress
            style={{ width: 15, height: 15 }}
            className="circular-progress-action-icon"
          />
        ) : (
          <SubMenuThreeDotIcon />
        )}
      </div>

      <Menu
        id="basic-menu"
        anchorEl={state?.anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
        className="users-list-menu-icon-menu"
        autoFocus={false}
      >
        {status === "brand_locked" ? (
          <MenuItem onClick={() => handleActionClick("unlock")}>
            Unlock brand
          </MenuItem>
        ) : (
          <MenuItem onClick={() => handleActionClick("lock")}>
            Lock brand
          </MenuItem>
        )}

        {status === "agency_draft" && (
          <MenuItem onClick={() => handleActionClick("approve")}>
            Approve agency draft
          </MenuItem>
        )}

        <MenuItem
          onClick={() =>
            handleActionClick(status === "active" ? "deactivate" : "activate")
          }
        >
          {status === "active" ? "Deactivate" : "Activate"}
        </MenuItem>

        <MenuItem
          onClick={() =>
            handleActionClick(isArchived ? "unarchive" : "archive")
          }
        >
          {isArchived ? "Unarchive" : "Archive"}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ActionMenuIcon;
